import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { X, Drop } from "@phosphor-icons/react";

export default function HydroMembershipModal({ open, onClose }) {
  const [settings, setSettings] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    if (open) {
      api.get("/settings/payment").then(({ data }) => setSettings(data));
    }
  }, [open]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && open) onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const goApply = () => {
    onClose();
    nav("/hydro/apply");
  };

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 sm:p-6 bg-black/80 backdrop-blur-sm rise-in"
      data-testid="hydro-modal"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl bg-[#0a0a0a] border border-[#D4AF37]/30 rounded-md overflow-hidden max-h-[92vh] flex flex-col"
        style={{ boxShadow: "0 30px 80px rgba(0,0,0,.6), 0 0 0 1px rgba(212,175,55,.18)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 h-9 w-9 rounded-full bg-black/60 border border-white/10 text-white/80 hover:text-white flex items-center justify-center"
          data-testid="hydro-modal-close"
        >
          <X size={18} />
        </button>

        <div className="px-6 sm:px-10 pt-8 pb-4 text-center border-b border-white/5">
          <div className="inline-flex items-center justify-center h-12 w-12 rounded-full bg-gold-gradient text-black mb-3">
            <Drop size={22} weight="duotone" />
          </div>
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37]">Exclusive privilege</p>
          <h2 className="font-display text-3xl sm:text-4xl text-white mt-2">Hydro Membership</h2>
          {settings?.hydro_membership_price > 0 && (
            <p className="text-white/60 text-sm mt-2">
              ₱{Number(settings.hydro_membership_price).toLocaleString()} · annual privilege
            </p>
          )}
        </div>

        <div className="overflow-y-auto px-6 sm:px-10 py-6 flex-1">
          {settings?.hydro_mechanics_image_url ? (
            <a href={settings.hydro_mechanics_image_url} target="_blank" rel="noreferrer" className="block">
              <img
                src={settings.hydro_mechanics_image_url}
                alt="Hydro Membership mechanics"
                className="w-full rounded-md border border-white/10"
                data-testid="hydro-mechanics-image"
              />
            </a>
          ) : (
            <div className="text-center py-12 border border-dashed border-white/10 rounded-md" data-testid="hydro-mechanics-empty">
              <p className="text-[10px] tracking-luxe uppercase text-white/40">Mechanics image not yet uploaded</p>
              <p className="text-white/55 text-sm mt-2">Our team is finalising the Hydro Membership mechanics. Please check back soon.</p>
            </div>
          )}
        </div>

        <div className="px-6 sm:px-10 py-5 border-t border-white/5 bg-[#070707] flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-white/55 text-xs">Apply in under a minute. Membership becomes Active after payment is verified.</p>
          <div className="flex items-center gap-3">
            <button onClick={onClose} className="text-white/60 hover:text-white text-[11px] tracking-luxe uppercase" data-testid="hydro-modal-cancel">Maybe later</button>
            <button onClick={goApply} className="tsc-btn-gold" data-testid="hydro-modal-join">Join Hydro</button>
          </div>
        </div>
      </div>
    </div>
  );
}
